import React from 'react';

import { distanceInWordsToNow } from 'date-fns';

import './Metric.css';

export default ({ translate, metric, icon, locale, name, style }) => (
  <div className="Metric" style={{ ...style }}>
    <div>{icon || 'icon'}</div>
    <div className="description">
      <div>{translate(`carView.healtStatus.${name}`)}</div>
      {!!(metric && metric.value) && (
        <div className="updatedAt">
          {translate('common.updatedAt')} {distanceInWordsToNow(metric.updatedAt, { addSuffix: true, locale })}
        </div>
      )}
    </div>
    {!!(metric && metric.value) && <div className="value">{Math.round(metric.value).toLocaleString()}</div>}
    {!(metric && metric.value) && <div className="value">{translate(`carView.healtStatus.unknown`)}</div>}
  </div>
);
